/**
* Logos Slider JS
* -----------------------------------------------------------------------------
*
* All the JS for the Logos Slider component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
import Splide from '@splidejs/splide';
( function( app ) {
  const COMPONENT = {

    className: 'logos-slider',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      $( '.logos-slider' ).each( function( key, component ) {
        const splide = new Splide( $( component ).find( '.splide--logos-slider' )[0], {
          type: 'loop',
          pagination: false,
          arrows: true,
          gap: '80px',
          autoWidth: true,
          perMove: 1,
        } );

        splide.mount();
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'logos-slider', COMPONENT );
} )( app );
